export enum BiEnum {
  TOP_PRODUCTS = "TOP_PRODUCTS",
  CATEGORY_PERFORMANCE = "CATEGORY_PERFORMANCE",
  BRAND_PERFORMANCE = "BRAND_PERFORMANCE",
  SALES_TRENDS = "SALES_TRENDS",
  TOP_BRANCHES = "TOP_BRANCHES",
  TOP_DEBTORS = "TOP_DEBTORS",
  PAYMENT_PREFERENCES = "PAYMENT_PREFERENCES",
  EXPENSE_BREAKDOWN = "EXPENSE_BREAKDOWN",
  INVENTORY_MOVEMENT = "INVENTORY_MOVEMENT",
  TOP_SALES_REP = "TOP_SALES_REP",
  TOP_B2B_CUSTOMERS = "TOP_B2B_CUSTOMERS",
  PROCUREMENT_TRENDS = "PROCUREMENT_TRENDS",
  TOP_SUPPLIERS = "TOP_SUPPLIERS",
  QUOTE_CONVERSION_FUNNEL = "QUOTE_CONVERSION_FUNNEL",
  CREDIT_NOTE_REASONS = "CREDIT_NOTE_REASONS",
}
